<script setup>
const props = defineProps({
    field: Object,
    item: Object
});
</script>

<template>
    <input
        v-model="item.value"
        class="form-control form-control-sm d-inline-block w-auto"
        maxlength="255"
    />
</template>